import { SitesBuilderLibComponent, Logo, SitesBuilderLibService, Viewerconfig } from '@3ddv/ngx-sites-builder-lib';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ToolsService } from '../services/tools.service';
import { Output, EventEmitter } from '@angular/core';
import { SblibService } from '../../services/sblib.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sbeditor-tool-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit, OnDestroy {

  public tool: Logo;
  public logoPreview: string | ArrayBuffer = '/assets/img/3ddv/3ddv.png';
  // public faviconPreview;
  private subscriptions: Array<Subscription>;
  private client: string;

  @Output() exportTool = new EventEmitter<Logo>();

  constructor(private toastr: ToastrService,
    private sblibService: SblibService,
    private activatedRoute: ActivatedRoute,
    private toolsService: ToolsService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.logo) {
        this.tool = Object.assign({}, res.logo);
        this.client = null;
        if (this.activatedRoute.snapshot.data.site?.site.title) {
          this.client = this.activatedRoute.snapshot.data.site.site.title;
        }


        if (this.tool.file) {
          this.loadPreviewImg(this.tool.file)
        } else if (this.tool.path && this.client) {
          this.loadPreviewFromPath()
        }
      } else {
        console.error("Logo tool not found");
        return;
      }
    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private loadPreviewFromPath() {
    this.logoPreview = environment.sitesBuilder.staticrsc_cdn + this.client + this.activatedRoute.snapshot.data.site.master.toolsConfig.logo.path;
    this.tool.default = false;
    this.tool.path = this.activatedRoute.snapshot.data.site.master.toolsConfig.logo.path;

    /*
    get cdn from library
      const sblibReady$ = this.sblibService.getSblibReady$().subscribe(res=>{
      const viewReady$ = this.sblibService.sblib?.viewerIsReady$().subscribe(viewerConfig=>{
      });
      this.subscriptions.push(viewReady$);
    });
    this.subscriptions.push(sblibReady$); */
  }

  public onFileDropped($event) {
    if (($event[0].type == "" && $event[0].size == 0) || ($event[0].type != 'image/jpeg' && $event[0].type != "image/png")) {
      this.toastr.error("", "Formato del fichero inválido");
      return;
    }
    this.tool.file = $event[0];
    this.loadPreviewImg($event[0])
  }

  public deleteDroppedFile() {
    this.tool.file = null;

    this.logoPreview = null;
    // this.faviconPreview = null;
    this.tool.path = '';
    this.tool.default = true;
  }

  public onFileSelected($event) {
    if (($event.target.files[0].type == "" && $event.target.files[0].size == 0) || ($event.target.files[0].type != 'image/jpeg' && $event.target.files[0].type != "image/png")) {
      this.toastr.error("", "Formato del fichero inválido");
      return;
    }
    this.tool.file = $event.target.files[0];
    this.loadPreviewImg($event.target.files[0])
  }

  public loadPreviewImg(file) {
    console.log('File img type: ', typeof file);
    console.log('File img: ', file);

    let ext = file.name.split('.').pop();
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_event) => {

      this.logoPreview = reader.result;
      this.tool.default = false;
      this.tool.path = "/latest/img/logo." + ext;
    }
  }

  public checkDefault() {
    if (this.tool.default) {
      this.tool.path = '';
      this.logoPreview = '/assets/img/3ddv/3ddv.png';
    } else {
      let d = this.activatedRoute.snapshot.data;
      if (this.tool.file) {
        this.loadPreviewImg(this.tool.file);
      } else if (d.site && d.master) {
        this.loadPreviewFromPath();
      }
    }
  }

  public getTool() {
    if (this.tool.default) {
      this.tool.file = null;
    }
    return this.tool;
  }
}
